import { render, staticRenderFns } from "./riskFactorItem.vue?vue&type=template&id=2e305e82"
import script from "./riskFactorItem.vue?vue&type=script&lang=js"
export * from "./riskFactorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e305e82')) {
      api.createRecord('2e305e82', component.options)
    } else {
      api.reload('2e305e82', component.options)
    }
    module.hot.accept("./riskFactorItem.vue?vue&type=template&id=2e305e82", function () {
      api.rerender('2e305e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/rft/riskFactorItem.vue"
export default component.exports